import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

import Hyvor from '../Chat/Hyvor';
import HyvorTalk from 'hyvor-talk-react';
import { HashLink } from 'react-router-hash-link';

const EntryMain = ({ diaryPage }) => {
  const WEBSITE_ID = 1987;
  const HEADLINE = diaryPage.headline.replace(/\s/g, '').toLowerCase();
  const PAGE_ID = HEADLINE;

  let newsContent;
  let image2;

  if (diaryPage.img2) {
    image2 = <img src={diaryPage.img2} alt={diaryPage.headline} />;
  } else {
    image2 = '';
  }

  if (diaryPage.type === 'Video') {
    newsContent = (
      <div className="newsVideo">
        <iframe
          title="YouTube"
          width="100%"
          height="384"
          src={diaryPage.ytEmbedLink}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  } else if (diaryPage.type === 'Image') {
    newsContent = (
      <div
        className="diaryPic"
        style={{
          backgroundImage: `url(${diaryPage.imageLink})`,
          height: `300px`,
          width: `100%`,
          backgroundSize: `contain`,
          backgroundPosition: 'center',
          backgroundRepeat: `no-repeat`,
        }}
      ></div>
    );
  } else if (diaryPage.type === 'Note') {
    newsContent = (
      <div
        className="diaryNote"
        style={{
          backgroundImage: `url(${diaryPage.imageLink})`,
          height: `300px`,
          width: `100%`,
          backgroundSize: `contain`,
          backgroundPosition: 'center',
          backgroundRepeat: `no-repeat`,
        }}
      ></div>
    );
  }
  return (
    <div>
      <Helmet>
        <title>JMKit.com: Dev Diary {diaryPage.headline}</title>
      </Helmet>
      <h1>News and Updates</h1>
      <div className="behindText articlePage">
        <div className="articleHeadline">
          <h1>{diaryPage.headline}</h1> <h3>{diaryPage.date}</h3>
        </div>
        <div className="commentCount">
          <HashLink to="#chat">
            <HyvorTalk.CommentCount websiteId={WEBSITE_ID} id={PAGE_ID} />
          </HashLink>
        </div>
        <h3 className="articleSection">{diaryPage.mainText1}</h3>
        <br />
        {newsContent}
        <br />
        {image2}
        <h4 className="articleSection">{diaryPage.mainText2}</h4>
        <h2 className="articleSection">{diaryPage.text2}</h2>
        <br />
        <Link to="/devdiary/">
          <div className="colorButton">
            <h3>Back to the Dev Diary Home page!</h3>
          </div>
        </Link>
      </div>
      <div id="chat">
        <Hyvor WEBSITE_ID={WEBSITE_ID} PAGE_ID={PAGE_ID} />
      </div>
    </div>
  );
};

export default EntryMain;
